export const NURSE_QUEUE_REFRESH_EVENT = 'funtoa:nurse-queue-refresh';

export function dispatchNurseQueueRefresh(siteId) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(NURSE_QUEUE_REFRESH_EVENT, {
      detail: { siteId: siteId != null ? Number(siteId) : null }
    })
  );
}
